module.exports = __webpack_public_path__ + "img/team-page.34e4d3d8.svg";